import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Element } from 'react-scroll';
import { getCollection } from '../actions/index';
import Banner from './banner/Banner';
import Wrapper from './wrapper/Wrapper';

class HomePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      collections: [],
    }
  }
  componentWillMount() {
    this.props.getCollection('posts').then(() => {
      if (this.props.collection) {
        this.setState({
          isLoading: false,
          collections: this.props.collection.entries,
        });
      };
    });
  }

  render() {
    const { isLoading, collections } = this.state;
    if (isLoading) {
      return <div className="loading" />
    }

    return (
      <div id="page-wrapper">
        <Element name="home">
          <Banner />
          <Wrapper collections={collections} />
        </Element>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { collection: state.collection.collection };
}

export default connect(mapStateToProps, { getCollection })(HomePage);




// WEBPACK FOOTER //
// ./src/components/HomePage.js